/**
 * Labstep
 *
 * @module state/reducers/index
 * @desc Reducers
 */

import { organizationAnalyticsApi } from 'labstep-web/rtk/services/organization-metric';
import { searchApi } from 'labstep-web/rtk/services/search';
import { ENTITIES_IN_REDUX_STATE } from 'labstep-web/services/schema/schema';
import { clientReducers } from 'labstep-web/state/new/client';
import { printReducers } from 'labstep-web/state/new/print';
import { prosemirrorReducers } from 'labstep-web/state/new/prosemirror';
import { sidebarReducer } from 'labstep-web/state/new/sidebar';
import { userSettingsReducer } from 'labstep-web/state/new/user-settings';
import { logoutAwareReducer } from 'labstep-web/state/reducers/helpers/logout';
import { activeEditModalSlice } from 'labstep-web/state/slices/activeEditModal';
import { activeGroupIdSlice } from 'labstep-web/state/slices/activeGroup';
import { activeMetabaseUrlSlice } from 'labstep-web/state/slices/activeMetabaseUrl';
import { globalSearchSlice } from 'labstep-web/state/slices/globalSearch';
import { jupyterReducers } from 'labstep-web/state/slices/jupyter';
import { paramsHocSlice } from 'labstep-web/state/slices/paramsHoc';
import { combineReducers } from 'redux';
import authenticatedUser from './authenticated-user';
import { getEntityReducers } from './entity';
import optimistic from './optimistic';
import urlParamsReducer from './params';
import proseMirrorReferencingSearch from './prosemirror-referencing-search';
import thumbnail from './thumbnail';
import ui from './ui';
import uiPersistent from './ui-persistent';
import websocket from './websocket';

export const entityReducers = ENTITIES_IN_REDUX_STATE.reduce(
  (acc, Entity) => ({
    ...acc,
    [Entity.entityName]: getEntityReducers(Entity.entityName),
  }),
  {},
);

export default {
  [activeEditModalSlice.name]: logoutAwareReducer(
    activeEditModalSlice.reducer,
  ),
  [activeGroupIdSlice.name]: logoutAwareReducer(
    activeGroupIdSlice.reducer,
  ),
  [activeMetabaseUrlSlice.name]: logoutAwareReducer(
    activeMetabaseUrlSlice.reducer,
  ),
  authenticatedUser: logoutAwareReducer(authenticatedUser),
  client: logoutAwareReducer(clientReducers),
  entities: logoutAwareReducer(combineReducers(entityReducers)),
  [globalSearchSlice.name]: logoutAwareReducer(
    globalSearchSlice.reducer,
  ),
  jupyter: logoutAwareReducer(jupyterReducers),
  optimistic,
  [organizationAnalyticsApi.reducerPath]:
    organizationAnalyticsApi.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  params: urlParamsReducer,
  [paramsHocSlice.name]: logoutAwareReducer(paramsHocSlice.reducer),
  print: printReducers,
  prosemirror: logoutAwareReducer(prosemirrorReducers),
  prosemirror_referencing_search: logoutAwareReducer(
    proseMirrorReferencingSearch,
  ),
  sidebar: sidebarReducer,
  thumbnail: logoutAwareReducer(thumbnail),
  ui,
  ui_persistent: logoutAwareReducer(uiPersistent),
  user_settings: userSettingsReducer,
  websocket,
};
